/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
const INITIAL_CONTEXT = {
  idle: {},
  VERIFY_OTP: {},
};

const MACHINE_CONFIG = {
  id: 'io.vlinder.platium-boilerplate.BuyInsurancePage.submit-kyc-data',
  initial: 'idle',
  context: INITIAL_CONTEXT,
  states: {
    idle: {
      entry: ['resetAction'],
      on: {
        START: { target: 'SUBMIT_KYC' },
      },
    },
    SUBMIT_KYC: {
      invoke: {
        id: 'submitKYC',
        src: 'submitKYC',
        onDone: {
          target: 'SUBMIT_KYC_SUCCESS',
          actions: ['successAction'],
        },
        onError: {
          target: 'SUBMIT_KYC_FAILED',
          actions: ['failureAction'],
        },
      },
    },
    SUBMIT_KYC_SUCCESS: {
      on: {
        START: { target: 'SUBMIT_KYC' },
      },
    },
    SUBMIT_KYC_FAILED: {
      on: {
        START: { target: 'SUBMIT_KYC' },
      },
    },
  },
};

//Machine(MACHINE_CONFIG)

export { INITIAL_CONTEXT, MACHINE_CONFIG };
